// extracted by mini-css-extract-plugin
export default {"SimplePhoneCartridge":"_J9lS"};